import { ItemButton } from './styled';
import { FilterProps } from '../../Filters/Filters';
import { DistinctFacetItem } from '~/lib/data-contract/auto-generated/loop54-api-model';
import { theme } from '~/theme';
import { FilteredNodeProps } from '../Desktop/NavigationFilter';
import ArrowLeft from '~/icons/iconography/arrow/left.svg';

type Props = FilteredNodeProps & {
    item?: DistinctFacetItem;
    facetName?: string;
    facetDisplayName?: string;
    resetCategoryPathFilter: boolean;
    onFilterClick?: (selected: FilterProps, facetName?: string, facetDisplayName?: string) => void;
};

export const NavigationFilterItem = ({
    facetDisplayName,
    facetName,
    filterValue,
    link,
    resetCategoryPathFilter,
    onFilterClick,
}: Props) => {
    return (
        <li>
            <ItemButton
                color={theme.colors.nightBlack}
                isSelected={!!filterValue?.selected}
                noIcon
                type="button"
                variant={resetCategoryPathFilter ? 'link' : 'stroke'}
                title={String(link?.title || link?.text || filterValue?.item)}
                onClick={() =>
                    onFilterClick?.(filterValue as FilterProps, facetName, facetDisplayName)
                }
            >
                {resetCategoryPathFilter ? <ArrowLeft /> : null}
                {link?.text} {filterValue?.count && `(${filterValue.count})`}
            </ItemButton>
        </li>
    );
};
